import React from "react";
import tw from "twin.macro";
import { motion } from "framer-motion";
import useInView from "helpers/useInView";

const StyledDiv = tw.div`font-display min-h-screen text-secondary-500 p-8 overflow-hidden`;

/**
 * AnimationReveal Component
 * Wrapper that animates its children with a "splash-in" effect.
 */
function AnimationReveal({ disabled, children }) {
  if (disabled) return <>{children}</>;

  // Ensure children is always an array for mapping
  const childElements = Array.isArray(children) ? children : [children];

  return (
    <>
      {childElements.map((child, index) => (
        <AnimatedSplashInComponent key={index}>
          {child}
        </AnimatedSplashInComponent>
      ))}
    </>
  );
}

/**
 * AnimatedSplashInComponent
 * Animates its children with a splash-in effect (fade-in with scale).
 */
function AnimatedSplashInComponent({ offset = 30, children }) {
  const [ref, inView] = useInView({
    margin: `-${offset}px 0px 0px 0px`, // Trigger animation slightly earlier
  });

  return (
    <div ref={ref}>
      <motion.section
        initial={{ opacity: 0, scale: 0.95 }} // Start slightly larger with opacity 0
        animate={{
          opacity: inView ? 1 : 0, // Fade in
          scale: inView ? 1 : 0.95, // Scale to normal size
        }}
        transition={{ duration: 0.4, ease: "easeIn" }}
      >
        {children}
      </motion.section>
    </div>
  );
}

// Main Animation Reveal Export
const SplashAnimationContainer = (props) => (
  <StyledDiv>
    <AnimationReveal {...props} />
  </StyledDiv>
);

export default SplashAnimationContainer;
